import ControlArea from "components/Layout/ControlArea";
import { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getAllPageSections } from "store/actions";
import Icon from "../../assets/svgs/projects.svg";
import Loader from "components/shared/Loader";
import Table from "./Table";

const Projects = () => {
  const { loading, error, sections } = useSelector((state) => state.section);
  const dispatch = useDispatch();
  const { formatMessage, locale } = useIntl();
  useEffect(() => {
    dispatch(getAllPageSections("projects"));
  }, [dispatch]);

  // error
  useEffect(() => {
    if (error) {
      toast.error(formatMessage({ id: "sendingErrorMessage" }), {
        position: locale === "ar" ? "bottom-left" : "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [error, formatMessage, locale]);

  if (loading) return <Loader />;

  return (
    <>
      <div className="services-wrap">
        <ControlArea
          btnTxt={<FormattedMessage id={"addProduct"} />}
          cardTxt={<FormattedMessage id={"products"} />}
          icon={Icon}
          url="/projects/add"
        />

        <Table data={sections} loading={loading} />
      </div>
    </>
  );
};

export default Projects;
